import React, { useEffect, useState } from 'react'
import { useDispatch,useSelector } from 'react-redux';
import { checkBoxAction } from './Redux/Feature/EmailSlice';
import { endDateAction, starDateAction, userDetailAction } from './Redux/Feature/UrlSlice';
import useSessionDetails from '../useSessionDetails';

const DateInput = ({ selectedPrice, selectedPlanName, onDateChange,selectedDateParam,dateDisabled,startDateAvailable,    selectedDateEnableProp,recommendedDate,selectedDateRedux,selectedDateEnablePropRedux ,togglePopup2,submitFunc}) => {

    const [selectedDateEnable, setSelectedDateEnable] = useState();
    const [selectedDateEnableRedux, setSelectedDateEnableRedux] = useState();

    const [disableDates, setDisableDates] = useState(new Date().toISOString().split('T')[0]);
    const [recommandateDisableDates, setRecommandateDisableDates] = useState();

      const storeselin = useSelector((state) => state);
    
  const {
    isTrial,
    trialDaysTime,
    paidDaysTime,
  } = useSessionDetails();

  // resolved


  const dispatch = useDispatch()
   
    const [isDateEnabled, setIsDateEnabled] = useState(storeselin?.emailData?.checkoboxCheck);
    const [isDateEnabledRedux, setIsDateEnabledRedux] = useState(storeselin?.emailData?.checkoboxCheck);

    const [popupDateData,setPopupDateData]= useState()

    //  useEffect(()=>{
    //     const queryParams = new URLSearchParams(window.location.search);
    //      const startDateParam = queryParams.get("startdate");
    //     if(isDateEnabled && startDateParam){
    //         dispatch(checkBoxAction(1));
    //     }else{
    //         dispatch(checkBoxAction(0)); 
    //     }
    //  },[isDateEnabled])
    // useEffect(() => {
    //   console.log("I checked the biox")
    //   // const queryParams = new URLSearchParams(window.location.search);
    //   // const startDateParam = selectedDateParam
    //   dispatch(checkBoxAction(selectedDateParam ? 1 : 0));
    // }, []);


    useEffect(() => {
        setRecommandateDisableDates(recommendedDate);
    
        if (selectedDateRedux < recommendedDate) {
            setPopupDateData(recommendedDate);
        } else if (selectedDateRedux > recommendedDate) {
            
            setPopupDateData(selectedDateRedux);
        } else if(selectedDateRedux === recommendedDate){
            
            setPopupDateData(selectedDateRedux);
        }
    
       
    }, [recommendedDate, selectedDateRedux]);
    

    



    useEffect(() => {
        setSelectedDateEnable(selectedDateEnableProp)
        setSelectedDateEnableRedux(selectedDateEnablePropRedux)
       
      }, [selectedDateEnableProp,selectedDateEnablePropRedux]);

      useEffect(() => {
        setIsDateEnabledRedux(selectedDateEnablePropRedux )
       
      }, [selectedDateEnablePropRedux]);

   
       useEffect(() => {
        if (!selectedDateParam) {
            setDisableDates(new Date().toISOString().split('T')[0]);
        } else {
            setDisableDates(selectedDateParam);
        }
    }, [selectedDateParam]);
    
    
      const handleDateChange = (event) => {
        const selectedDate = event.target.value;
        if (onDateChange) {
          onDateChange(selectedDate);
   
        }else{
            dispatch(starDateAction(selectedDate))
            setPopupDateData(selectedDate)//change krna pdega shayd---
        }
      };

   
      // const handleCheckboxChange = () => {
        

       
      //   setIsDateEnabled(!isDateEnabled);
      //   setSelectedDateEnable(!selectedDateEnable)

       
       
      // };


      //   const handleCheckboxChangeRedux = () => {
           
      //       setIsDateEnabledRedux(!isDateEnabledRedux);
      //       setSelectedDateEnableRedux(!selectedDateEnableRedux);
      //       handleChangeDates()
       
      //     };

      const handleCheckboxChange = () => {
        setIsDateEnabled(prev => {
          console.log("storeselin?.emailData?.checkoboxCheck", storeselin?.emailData?.checkoboxCheck)
          const next = !storeselin?.emailData?.checkoboxCheck;
          dispatch(checkBoxAction(next ? 1 : 0));
          return next;
        });
        setSelectedDateEnable(prev => !prev);
      };
      
      const handleCheckboxChangeRedux = () => {
        setIsDateEnabledRedux(prev => {
          const next = !storeselin?.emailData?.checkoboxCheck;
          dispatch(checkBoxAction(next ? 1 : 0));
          return next;
        });
        setSelectedDateEnableRedux(prev => !prev);
        handleChangeDates();
      };


        const handleChangeDates =()=>{
         
         if (selectedDateRedux > recommendedDate || selectedDateRedux == recommendedDate) {
           setPopupDateData(recommendedDate);
            }

        }

        const RenewalFunc =()=>{
         const checkboxValue = isDateEnabledRedux ? 1 : 0;

            dispatch(checkBoxAction(checkboxValue));

            console.log("Date LOG1", popupDateData, isTrial, trialDaysTime, paidDaysTime)

            let expirydate = new Date(
              `${popupDateData}T00:00:00`
            );

            console.log("Expiry date before", expirydate);

            expirydate.setDate(
              expirydate.getDate() +
                Number(isTrial ? trialDaysTime : paidDaysTime)
            );

            let date_ob = new Date(expirydate);
            let date = ("0" + date_ob.getDate()).slice(-2);
            let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
            let year = date_ob.getFullYear();
            expirydate = year + "-" + month + "-" + date;

            console.log("Final expiry date", expirydate);

            dispatch(endDateAction(expirydate))
        
          
            dispatch(starDateAction(popupDateData));


            togglePopup2()
            submitFunc()
        }

        console.log(selectedDateParam,selectedDateRedux,"selecteddate")
      return (
        <>
           {selectedDateRedux > recommendedDate  && 
            
            <p className='changeDate-link'  onClick={handleChangeDates}>Change my start date to recommended start date</p>
            } 

        <div className="date-input-div">
          <label>Select Start Date</label>
          <div>
          <input
            placeholder="Start Date"
            type="date"
            name="Startdate"
            className="home-input"
            defaultValue={selectedDateParam || popupDateData || ''}
            onChange={handleDateChange}
            
            min={recommandateDisableDates || disableDates  || ''}

            disabled={storeselin?.emailData?.checkoboxCheck == 1 ? true : false}
          />
          <br/>
         
          <br/>

       { selectedDateParam !== ''  && selectedDateParam !== undefined && selectedDateParam !== null && (
        <div className="checkbox-container">
          <label>
          <input
            type="checkbox"
            checked={isDateEnabled}
            onChange={handleCheckboxChange}
          />
             &nbsp;I want my plan to continue after expiry.<br/><span className='plan-validity'>Which means your plan will be continued either after the expiry date or the day after you consume your last class of your current active plan.</span>
          </label>
        </div>
        )}

      {selectedDateRedux !== '' && selectedDateRedux !==  undefined && selectedDateRedux !== null && (
        <div className="checkbox-container">
          <label>
          <input
            type="checkbox"
            checked={isDateEnabledRedux}
            onChange={handleCheckboxChangeRedux}
          />
             &nbsp;I want my plan to continue after expiry.<br/><span className='plan-validity'>Which means your plan will be continued either after the expiry date or the day after you consume your last class of your current active plan.</span>
          </label>
        </div>
        )}


    


        </div>
        </div>

        {selectedDateRedux && recommendedDate &&
        <button className='next-btn' onClick={RenewalFunc}>Next</button>
        }

        </>
      );
}

export default React.memo(DateInput);